import React from 'react';
import { Container } from 'react-bootstrap';

const PrivacyPolicyPage = () => {
  return (
    <div className="text-start bg-light py-5">
      <Container className="bg-white p-5 rounded shadow" style={{ maxWidth: '900px' }}>
        <h2 className="text-center fw-bold text-primary mb-4 text-uppercase">Privacy Policy</h2>

        <p>
          Welcome to Warals Technology and Warals school mobile application for Android and iOS operating systems,
          a cloud-based ERP product available for educational organizations on a subscription basis. It can be accessed
          through the web and mobile applications (collectively owned and managed by Warals Technology Private Limited).
        </p>

        <p>
          <strong>IMPORTANT:</strong> This document contains very important information regarding your rights,
          obligations, conditions, limitations, and exclusions that might apply to you. Please read it carefully.
        </p>

        <p>
          This Privacy Policy explains how Warals Technology, the developer of WSMS, collects, uses, and protects user
          information. Warals Technology is responsible for managing the personal and sensitive data collected by this app.
        </p>

        <p>
          Warals Technology is committed to protecting your privacy. This Privacy Policy explains how we collect, use,
          and protect information about you when you use our education management software and mobile app, which may
          integrate services provided by Google Console. By using our services, you agree to the collection and use
          of information in accordance with this policy.
        </p>

{/* numberings */}
        <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          1. Information We Collect
        </h5>
        <p>
          We collect several types of information to provide and improve our services, including:
        </p>

        <ul>
          <li>
            <strong>Personal Information:</strong> When you register or use our software or mobile app, we may collect
            personal information such as your name, email address, phone number, and educational institution details.
          </li>
          <li>
            <strong>Device Information:</strong> We collect information about the devices you use to access our services,
            such as IP address, operating system, device ID, and browser type.
          </li>
          <li>
            <strong>Usage Data:</strong> We may collect data about how you interact with our services, including log-in
            times, page views, and feature usage within the app.
          </li>
          <li>
            <strong>Google Console Data:</strong> In some instances, our app may integrate Google services. If so, we may
            collect or access information as permitted by your Google account or Google API, such as device information,
            authentication tokens, and activity logs.
          </li>
        </ul>

         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          2. How We Use Your Information
        </h5>
        <p>
         We use the collected information for various purposes, including:
        </p>

        <ul>
          <li>
           To provide, maintain, and improve our software and mobile app.
          </li>
          <li>
           To manage user accounts and provide customer support.
          </li>
          <li>
            To personalize your experience and present relevant content or features.
          </li>
          <li>
            To analyze usage data to improve performance and enhance user satisfaction.
          </li>
          <li>
            To communicate with you about updates, changes, or issues related to the service.
          </li>
          <li>
            To comply with legal obligations and prevent misuse of our services.
          </li>
        </ul>

         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          3. Use of Google Console Services
        </h5>
        <p>
          Our services may incorporate tools from Google Console, including but not limited to Google Play, Firebase, and Google APIs. Data collected via Google Console is used to:
        </p>

        <ul>
          <li>
           Analyze app performance (e.g., crash logs, analytics).
          </li>
          <li>
            Improve app functionality and user experience.
          </li>
          <li>
            Provide cloud storage or authentication features where applicable.
          </li>
        </ul>
         <p>
         For more information on how Google uses and processes data, please review Google’s own Privacy Policy.
        </p>

         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          4. Data Sharing and Disclosure
        </h5>
        <p>
          We do not sell or trade your personal information. We may share information in the following situations:
        </p>

        <ul>
          <li>
            <strong>Service Providers:</strong> We may share data with third-party service providers who help us operate, improve, and support our services (e.g., cloud storage, payment processing, analytics).
          </li>
          <li>
            <strong>Compliance with Law:</strong> We may disclose your information if required by law, to comply with legal processes, or to protect our rights and safety.
          </li>
          <li>
            <strong>Business Transfers:</strong> In the event of a merger, acquisition, or asset sale, your information may be transferred as part of that transaction.
          </li>
        </ul>
         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          5. Data Security
        </h5>
        <p>
          We take appropriate technical and organizational measures to protect your data from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet is completely secure, and we cannot guarantee the absolute security of your data.
        </p>
         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          6. Data Retention
        </h5>
        <p>
          We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected. When your data is no longer needed, we will securely delete or anonymize it.
        </p>
         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          7. Your Rights
        </h5>
        <p>
          You have the following rights concerning your personal information:
        </p>

        <ul>
          <li>
            <strong>Access:</strong> You can request access to the personal data we hold about you.
          </li>
          <li>
            <strong>Correction:</strong> You can request corrections to inaccurate or incomplete information.
          </li>
          <li>
            <strong>Deletion:</strong> You can request the deletion of your data under certain conditions.
          </li>
          <li>
            <strong>Opt-Out:</strong> You can opt out of receiving marketing communications at any time.
          </li>
        </ul>
         <p>
          To exercise any of these rights, please contact us at <a href="mailto:support@waralstech.com" className="text-black text-decoration-none">support@waralstech.com</a>.
        </p>
         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          8. Changes to This Privacy Policy
        </h5>
        <p>
         We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
        </p>
         <h5 className="border-start border-4 border-primary ps-3 fw-bold mt-5">
          9. Contact Us
        </h5>
        <hr></hr>
        <p>
          If you have any questions about this Privacy Policy or how we handle your data, please contact us at:
        </p>
        <strong>Warals Technology</strong>
        <p>
          Email:  <a href="mailto:info@warals.com" className="text-black text-decoration-none">info@warals.com</a> <br></br>
          Phone:<a href="tel:+919871115060" className="text-black text-decoration-none"> +919871115060</a>
        </p>
      </Container>
    </div>
  );
};

export default PrivacyPolicyPage;
